import { useState, useEffect, useMemo } from "react";
import { LOYALTY_API_BASE } from "../constants";
import { loyaltyFetch } from "./loyaltyFetch";
import { resolveSegmentsUi, SEGMENT_UI_DEFAULTS } from "../utils/segmentUiCatalogDefaults";

/**
 * GET /admin/segments/ui-catalog — règles machine-readable (workflow create/update/delete/members).
 * Échec silencieux : l'UI utilise SEGMENT_UI_DEFAULTS (aucun blocage).
 */
export function useSegmentsUiCatalog(brandName) {
    const [catalog, setCatalog] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!brandName) {
            setCatalog(null);
            return;
        }
        let cancelled = false;
        setLoading(true);
        loyaltyFetch(`${LOYALTY_API_BASE}/admin/segments/ui-catalog`, {
            headers: { "X-Brand": brandName },
        })
            .then(async (res) => {
                const data = res.ok ? await res.json().catch(() => null) : null;
                if (!cancelled) setCatalog(data);
            })
            .catch(() => { if (!cancelled) setCatalog(null); })
            .finally(() => { if (!cancelled) setLoading(false); });
        return () => { cancelled = true; };
    }, [brandName]);

    const ui = useMemo(() => resolveSegmentsUi(catalog), [catalog]);

    return {
        catalog,
        ui,
        defaults: SEGMENT_UI_DEFAULTS,
        loading,
    };
}

export default useSegmentsUiCatalog;
